import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomePage from '../views/Home.vue'
import DeviceRedirect from '@/views/DeviceRedirect.vue'
import AiChat from '@/views/AiChat.vue'
import WebChat from '@/views/WebChat.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/home',
  //   name: 'HomePage',
  //   component: HomePage
  // },
  {
    path: '/',
    name: 'deviceRedirect',
    component: DeviceRedirect
  },
  // {
  //   path: '/jump',
  //   name: 'jumpPage',
  //   component: JumpPage
  // },
  {
    path: '/chat',
    name: 'chatPage',
    component: AiChat
  },
  {
    path: '/webChat',
    name: 'WebChat',
    component: WebChat
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
